import client from '../axios';
import {
  GET_LINKED_BRANCH,
  GET_SCHOOL_CELL_PHONE_CHECK,
  GET_SCHOOL_DETAIL,
  GET_SCHOOL_INFO,
  GET_SCHOOL_LEADER_NAME_CHECK,
  GET_STORECOUNSEL,
  POST_ORDERFIRST_FIRST,
  POST_SCHOOL,
  POST_SCHOOL_BUSINESSLICENSE,
  POST_SCHOOL_PRIVATETUTOR,
  POST_ORDERFIRST_SECOND,
  PUT_SCHOOL,
  PUT_SCHOOL_BUSINESSLICENSE,
  PUT_SCHOOL_NEWCURRICULUM,
  PUT_SCHOOL_OPENDOC,
  PUT_SCHOOL_ORDERLIMIT,
  PUT_SCHOOL_PRIVATETUTOR,
  PUT_SCHOOL_REQUESTDOC,
  PUT_SCHOOL_REQUIRECURRICULUM,
  GET_MEMBER_STUDY
} from './endpoint';

// 회원관리
export const getSchoolMemberListAPI = () => {
  return client.get();
};
export const getSchoolMemberDetailAPI = () => {
  return client.get();
};

// 입회상담 관리
export const getSchoolJoinCounselListAPI = () => {
  return client.get();
};
export const getSchoolJoinCounselDetailAPI = () => {
  return client.get();
};
export const getSchoolJoinApprovalListAPI = () => {
  return client.get();
};

// 강사관리
export const getSchoolTeacherListAPI = () => {
  return client.get();
};
export const getSchoolTeacherDetailAPI = () => {
  return client.get();
};

// 물품 주문관리
export const getSchoolProductListAPI = () => {
  return client.get();
};
export const getSchoolProductDetailAPI = () => {
  return client.get();
};

// 물품 장바구니
export const getSchoolProductCartListAPI = () => {
  return client.get();
};

// 주문내역/요청
export const getSchoolOrderHistoryListAPI = () => {
  return client.get();
};
export const getSchoolOrderHistoryDetailAPI = () => {
  return client.get();
};

// 교재 주문수정/교환내역
export const getSchoolOrderUpdateListAPI = () => {
  return client.get();
};

// 물품 환불관리
export const getSchoolProductReFundListAPI = () => {
  return client.get();
};
export const getSchoolProductReFundDetailAPI = () => {
  return client.get();
};

// 회수내역
export const getSchoolRecoveryListAPI = () => {
  return client.get();
};
export const getSchoolRecoveryDetailAPI = () => {
  return client.get();
};

// 회원별 교재내역
export const getSchoolOrderMemberListAPI = () => {
  return client.get();
};

// 적립금 내역
export const getSchoolPointListAPI = () => {
  return client.get();
};

// 교육원 팝콘 정보
export const getSchoolInfoAPI = (idx) => {
  return client.get(GET_SCHOOL_INFO.replace(':school_idx', idx));
};

// 교육원 수정
export const putSchoolAPI = (data) => {
  return client.put(PUT_SCHOOL, data);
};

// 교육원 등록
export const postSchoolAPI = (data) => {
  return client.post(POST_SCHOOL, data);
};

// 교육원 상세
export const getSchoolDetailAPI = (idx) => {
  return client.get(GET_SCHOOL_DETAIL.replace(':school_idx', idx));
};

// 교육원 등록 대상 목록(가맹상담리스트)
export const getStoreCounselListAPI = (params) => {
  return client.get(GET_STORECOUNSEL, {params});
};

export const getLinkedBranchAPI = (params) => {
  return client.get(GET_LINKED_BRANCH, {params});
}

// 교육원 수정(신규교육과정)
export const putSchoolNewcurriculumAPI = (data) => {
  return client.put(PUT_SCHOOL_NEWCURRICULUM, data);
};

// 교육원 수정(필수교육과정)
export const putRequirecurriculumAPI = (data) => {
  return client.put(PUT_SCHOOL_REQUIRECURRICULUM, data);
};

// 교육원 수정(교육원요청서류)
export const putRequestdocAPI = (data) => {
  console.log(data)
  return client.put(PUT_SCHOOL_REQUESTDOC, data);
};

// 교육원 수정(교육원개점서류)
export const putOpendocAPI = (data) => {
  return client.put(PUT_SCHOOL_OPENDOC, data);
};

// 교육원 1차 초도물품 신청
export const postOrderfirstFirstAPI = (data) => {
  return client.post(POST_ORDERFIRST_FIRST, data);
};

// 교육원 2차 초도물품 신청
export const postOrderfirstSecondAPI = (data) => {
  return client.post(POST_ORDERFIRST_SECOND, data);
};

// 교육원 수정(주문제한)
export const putOrderlimitAPI = (data) => {
  return client.put(PUT_SCHOOL_ORDERLIMIT, data);
};

export const getLeaderNameCheckAPI = (data) => {
  return client.get(GET_SCHOOL_LEADER_NAME_CHECK, {params: {school_leader_name: data}});
};

export const getShoolPhoneCheck = (data) => {
  return client.get(GET_SCHOOL_CELL_PHONE_CHECK, {params: {phone: data}});
};

// 개인과외/학원/교습소신고등록증 등록
export const PostSchoolPrivatetutorAPI = (data) => {
  return client.post(POST_SCHOOL_PRIVATETUTOR, data);
};

// 개인과외/학원/교습소신고등록증 수정
export const PutSchoolprivatetutorAPI = (data) => {
  return client.put(PUT_SCHOOL_PRIVATETUTOR, data);
};

// 사업자등록증 등록
export const PostSchoolBusinesslicenseAPI = (data) => {
  return client.post(POST_SCHOOL_BUSINESSLICENSE, data);
};

// 개인과외/학원/교습소신고등록증 수정
export const PutSchoolBusinesslicenseAPI = (data) => {
  return client.put(PUT_SCHOOL_BUSINESSLICENSE, data);
};

// 회원관리-학습진도
export const GetMemberStudyAPI = (data) => {
  const url = GET_MEMBER_STUDY.replace(':member_idx', data.idx).replace(':base_year_month', data.base_year_month)
  return client.get(url);
};
